<template>
    <div v-if="programmes != null && (!individual_days || (individual_days && programmes.length > 1)) && !isQuickAdd">

        <div class="switch-box-fixed">
            <div class="switch-package-container">
                <transition name="fade">
                    <a @click="switcher" v-if="show_switch_option == 'weeks'" v-html="this.$root.locale.booking.packages.text_switch_to_full_weeks"></a>
                    <a @click="switcher" v-else-if="show_switch_option == 'days'" v-html="this.$root.locale.booking.packages.text_switch_to_individual_days"></a>
                    <!-- <a href="https://www.kingscamps.org/booking-request" v-else-if="show_switch_option == 'days'" v-html="this.$root.locale.booking.packages.text_switch_to_individual_days"></a> -->
                </transition>
            </div>
		</div>

        <div v-for="programme in programmes">
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <div class="box-layout-inner select-a-package">
                    <div v-if="programme.package_state_id == 4  || (!programme.isAvailable && (programme.prog_id == 1 || programme.prog_id == 17 || programme.prog_id == 18))" class="ribbon-wrapper">
                        <div class="ribbon" v-html="locale.ribbon_sold_out"></div>
                    </div>
                    
                    <div class="block-inner-image" v-bind:style="{ background: 'url('+ programme.image_url +') center center / cover no-repeat' }">
                    </div>

                    <div class="title-block-alt">
                        <div class="alt-container">
                            <span>{{ programme.name }}</span>
                            <b class="price">£{{ programme.price }} / {{ programme.price_per }}</b>
                        </div>
                    </div>

                    <div class="content-block">
                        <transition-group name="list">
                            <div class="hidden-sm hidden-md hidden-lg" v-bind:key="0">
                                <span class="full-description" v-if="descriptions.indexOf(programme.id) > -1" v-html="programme.full_description"></span>
                                <span class="short-description" v-else>
                                    <p v-html="programme.short_description"></p> <a @click="readMore(programme.id)" class="cta-button blue">Read more</a>
                                </span>
                            </div>

                            <div class="hidden-xs" v-bind:key="1">
                                <span class="full-description" v-html="programme.full_description"></span>
                            </div>
                        </transition-group>
                    </div>

                    <div v-if="!individual_days" class="full-width-cta">
                        <a @click="progress(this, programme)" class="cta-button red" v-if="programme.package_state_id == 2 && ((programme.prog_id != 1 && programme.prog_id != 17 && programme.prog_id != 18) || ((programme.prog_id == 1 || programme.prog_id == 17 || programme.prog_id == 18) && Object.values(programme.availability).every(num => num > 0)))" v-html="locale.button_on_sale"></a>
                        <a class="cta-button blue" v-else-if="programme.prog_id == 1 && (programme.package_state_id == 4 || (Object.values(programme.availability).some(num => num <= 0)))" v-html="locale.button_click_to_subscribe_multi_acitve"></a>
                        <a class="cta-button blue" v-else-if="(programme.prog_id == 17 || programme.prog_id == 18) && (programme.package_state_id == 4 || (Object.values(programme.availability).some(num => num <= 0)))" v-html="locale.button_click_to_subscribe"></a>
                        <a class="cta-button blue" v-else-if="programme.package_state_id == 3" v-html="locale.button_call_to_book"></a>
                    </div>
                    <div v-else class="full-width-cta">
                        <a @click="progress(this, programme)" class="cta-button red" v-if="programme.package_state_id == 2 && ((programme.prog_id != 1 && programme.prog_id != 17 && programme.prog_id != 18) || ((programme.prog_id == 1 || programme.prog_id == 17 || programme.prog_id == 18) && programme.isAvailable))" v-html="locale.button_on_sale"></a>
                        <a class="cta-button blue" v-else-if="programme.package_state_id == 4 || (!programme.isAvailable && (programme.prog_id == 1 || programme.prog_id == 17 || programme.prog_id == 18))" v-html="locale.button_click_to_subscribe"></a>
                        <a class="cta-button blue" v-else-if="programme.package_state_id == 3" v-html="locale.button_call_to_book"></a>
                    </div>

                </div>
            </div>
        </div>
        
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" v-show="programmes.length == 0">
            <div class="box-layout-inner">
                <div class="title-block" v-html="locale.text_empty"></div>
            </div>
        </div>
    </div>
    <div v-else-if="programmes != null && isQuickAdd">
        <div class="fields dropdown" v-if="programmes.length > 0">
            <label for="bases_available">Programme<small v-if="!quickSelection.base"> - Please select a programme</small></label>

            <div class="dropdown-inner">
                <select name="bases_available" id="bases_available
                " v-model="quickSelection.base">
                    <option v-for="programme in programmes" :value="programme" v-html="programme.name + (programme.package_state_id != 2 ? ' - ' + programme.package_state_readable : '' ) + ' (For ages: ' + programme.min_age + ' to ' + programme.max_age + ')'" :disabled="programme.package_state_id != 2"></option>
                </select>

                <i class="fa fa-chevron-down"></i>
            </div>
        </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" v-else>
        <div class="box-layout-inner">
            <p class="text-center" v-if="loading"><i class="fa fa-spinner fa-pulse fa-5x dark"></i></p>
            <div class="title-block" v-else-if="!loading && age <= 4" v-html="locale.text_empty_4_years"></div>
            <div class="title-block" v-else v-html="locale.text_empty"></div>
        </div>
    </div>

</template>

<script>
    export default {
        props: ['quick', 'quickSelection', 'participant', 'package'],
        data () {
            return {
                programmes: null,
                age: null,
                loading: true,
                min_age: null,
                week: null,
                individual_days: false,
                show_switch_option: true,
                descriptions: [],
            }
        },
        watch: {
            '$route.query': {
                handler: function () {
                    this.refresh();
                },
                deep: true
            },
			'quickSelection.week': {
                handler: function () {
                    this.refresh();
                },
                deep: true
            }
        },
        computed: {
            isQuickAdd: function () {
                return this.quick != undefined && this.quick == true;
            },
            locale: function () {
                return this.$root.locale.booking.base_packages;
            }
        },
        methods: {
            readMore: function (programmeId) {
                this.descriptions.push(programmeId);
            },
            switcher: function () {
                //{ name: 'booking.weeks', query: { age: (this.$route.query.hasOwnProperty('age') ? this.$route.query.age : null), min_age: (this.$route.query.hasOwnProperty('min_age') ? this.$route.query.min_age : null) } }

                var individual_days = this.show_switch_option == 'days';
                this.show_switch_option = false;

                // Change min_age to 15 and age to 17 if current min_age is 5 and age is 14 (switching from weekly MA to individual days should switch the age range from 5-14 to 15-17, and switching back should switch it back to 5-14)
                if (
                    this.$route.query.hasOwnProperty('min_age') &&
                    this.$route.query.hasOwnProperty('age')
                ) {
                    // If current is 5-14, switch to 15-17
                    if (this.$route.query.min_age == 5 && this.$route.query.age == 14) {
                        this.$router.push({
                            name: 'booking.weeks',
                            query: { age: 17, min_age: 15 }
                        });
                        return;
                    }
                    // If current is 15-17, switch to 5-14 and add days: true
                    if (this.$route.query.min_age == 15 && this.$route.query.age == 17) {
                        this.$router.push({
                            name: 'booking.packages',
                            query: { age: 14, min_age: 5}
                        });
                        return;
                    }
                }
                
                // //unsetting any age variables set in builder
                // if(this.$root.builder.hasOwnProperty('min_age'))
                //     delete this.$root.builder.min_age;
                // if(this.$root.builder.hasOwnProperty('age'))
                //     delete this.$root.builder.age;

                // this.$router.push({
                //     name: !this.individual_days ? 'booking.weeks' : 'booking.packages',
                //     query: {
                //         days: !this.individual_days ? undefined : true
                //     }
                // });
            },
            refresh: function () {
                var age = this.age = (this.$route.query.hasOwnProperty('age') ? this.$route.query.age : (this.$root.builder.hasOwnProperty('age') ? this.$root.builder.age : null));
                var min_age = this.min_age = (this.$route.query.hasOwnProperty('min_age') ? this.$route.query.min_age : (this.$root.builder.hasOwnProperty('min_age') ? this.$root.builder.min_age : null));
                var week = this.week = (this.$route.query.hasOwnProperty('week') ? this.$route.query.week : (this.$root.builder.hasOwnProperty('date') ? this.$root.builder.date.id : null));
                var individual_days = this.individual_days = (this.$route.query.hasOwnProperty('days') ? this.$route.query.days : (this.$root.builder.hasOwnProperty('individual_days') ? this.$root.builder.individual_days : null));

                //Changing individual_days to an object if not already
                if(individual_days instanceof String)
                    individual_days = this.individual_days = (individual_days == 'true')

                if(week == null && !individual_days && !this.isQuickAdd)
                    this.$router.push({ name: 'booking.weeks' });

                /**
                 * Getting all the venues to fill the select dropdown to select a venue.
                 */
                 var d = new Date();
                 var day = d.getDay(),
                 diff = d.getDate() - day + (day == 0 ? -6:1); // adjust when day is sunday
                 var first_day_of_week = new Date(d.setDate(diff));
                axios.get('camp-booking/packages', {
                    params: {
                        // price_per: (individual_days ? 'day' : 'week'),
                        min_start_date: (individual_days ? first_day_of_week.toISOString().split('T')[0] : null), //now.toISOString().split('.')[0] // JT: Causing dates that have already started to not show, shouldn't be required as long as venue_week_id is being provided
                        age: (this.isQuickAdd ? null : age),
                        venue_week_id: (individual_days ? null : (this.isQuickAdd ? this.quickSelection.week : week)),
                        venue_id: this.$route.params.venueId,
                        only_base_packages: true.toString(),
                        hide_internal: true
                    }
                }).then(response => {
                    var ids = [];
                    this.programmes = response.data.data.filter(item => {

                        if(ids.indexOf(item.package_template_id) > -1)
                            return false

                        if(this.quick && this.quickSelection.base > 0 && item.id == this.quickSelection.base)
                            this.quickSelection.base = item;
                        else if(this.quick && this.package != undefined && this.package.estimated_base_package_template_id == item.package_template_id)
                            this.quickSelection.base = item;

                        // Push the programmes that are with prog_id 1, 17 and 18 to the individual day packages if they are not already there, as long as they are not already added to the list of programmes (to avoid duplicates)
                        // If this.individual_days is false, we want to show the week packages, so we should not add the prog_id 1, 17 and 18 packages to the list of programmes as they are only relevant for individual day packages
                        if (this.age === 14) {
                            // Only add prog_id 1, 17, 18 for individual days, avoid duplicates
                            if ((item.prog_id == 1 || item.prog_id == 17 || item.prog_id == 18) && ids.indexOf(item.package_template_id) === -1) {
                                ids.push(item.package_template_id);
                            } else {
                                return false;
                            }
                        } else if (this.age === 17) {
                            // For week packages, exclude prog_id 1, 17, 18
                            if (item.prog_id != 1 && item.prog_id != 17 && item.prog_id != 18 && ids.indexOf(item.package_template_id) === -1) {
                                ids.push(item.package_template_id);
                            } else {
                                return false;
                            }
                        } else {
                            return false;
                        }
                        return true;

                    }).map(item => {
                        let availabilityStatus = false;

                        // Check the availability property and determine the new key's value
                        if (item.availability && typeof item.availability === 'object') {
                        // Check if at least 3 values in the array are positive
                        const nonZeroCount = Object.values(item.availability).filter(value => value >= 0).length;
                        availabilityStatus = nonZeroCount >= 3;
                        this.show_switch_option='days';
                        } else if (typeof item.availability === 'number') {
                            this.show_switch_option='weeks';
                        // Check if the integer is non-zero
                        availabilityStatus = item.availability >= 0;
                        }

                        // Add a new key to each filtered item
                        return Object.assign({}, item, { isAvailable: availabilityStatus });
                    }).reverse();
                    this.programmes.sort(function(a, b) {

                        const aPrice = Number(a.price);
                        const bPrice = Number(b.price);
                        let aState = Number(a.package_state_id);
                        let bState = Number(b.package_state_id);

                        const priorityOrder = [1, 17, 18, 2]; // Define the priority order for prog_id

                        const aPriority = priorityOrder.indexOf(Number(a.prog_id));
                        const bPriority = priorityOrder.indexOf(Number(b.prog_id));

                        if ((Number(a.prog_id) === 1 || Number(a.prog_id) === 17 || Number(a.prog_id) === 18) && Object.values(a.availability || {}).some(num => num <= 0)) {
                            aState = 4;
                        }

                        if ((Number(b.prog_id) === 1 || Number(b.prog_id) === 17 || Number(b.prog_id) === 18) && Object.values(b.availability || {}).some(num => num <= 0)) {
                            bState = 4;
                        }

                        // Step 1: Sort by package_state_id
                        if (aState !== bState) {
                            return aState - bState;
                        }

                        // Step 2: Sort by priority order of prog_id
                        if (aPriority !== bPriority) {
                            return aPriority - bPriority;
                        }

                        // Step 3: Sort by name alphabetically
                        if (a.name.toLowerCase() !== b.name.toLowerCase()) {
                            return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
                        }

                        // Step 4: Fallback to price
                        return aPrice - bPrice;
                    });

                    // Remove duplicate Multi Active packages, keeping only the last one
                    const multiActiveIndices = [];
                    this.programmes.forEach((prog, index) => {
                        if(Number(prog.prog_id) === 1) {
                            multiActiveIndices.push(index);
                        }
                    });

                    if (multiActiveIndices.length > 1) {
                        // Choose the programe with the most number of days running
                        let maxDaysRunning = 0;
                        let indexToKeep = multiActiveIndices[0];
                        multiActiveIndices.forEach(index => {
                            const daysRunning = Object.values(this.programmes[index].days_running).length;
                            if (daysRunning > maxDaysRunning) {
                                maxDaysRunning = daysRunning;
                                indexToKeep = index;
                            }
                        });
                        // Remove all other Multi Active programmes except the one to keep
                        multiActiveIndices.forEach(index => {
                            if (index !== indexToKeep) {
                                this.programmes.splice(index, 1);
                            }
                        });
                    }

                    /**
                     * Going back if there are no base packages with the current selection
                     **/
                    if(this.programmes.length == 0) {
                        this.$root.alert(this.locale.text_empty);
                        this.$router.push({ name: 'booking.weeks', query: {
                            min_age,
                            max_age: age
                        } });
                        return false;
                    }

                    /**
                     * Skipping to the next page if there is only one package or we are on days only root
                     */
                    if(
                        (this.programmes.length == 1 && !this.isQuickAdd && !this.$route.query.hasOwnProperty('back'))
                    ) {
                        this.progress(null, this.programmes[0]);
                        return false;
                    }

                    /**
                     * Setting the headers
                     **/
                    if(!this.isQuickAdd) {
                        var breadcrumbs = [{
                            to: {name: 'booking.age', query: {}},
                            title: (this.individual_days ? 'Multi Active Programmes' : 'Rookie Academy Programmes')
                        }];
                        if (!individual_days) {
                            var start = new Date(this.programmes[0].start_date);

                            breadcrumbs.push({
                                to: {name: 'booking.weeks', query: {min_age: (min_age != null ? min_age : undefined), max_age: (age != null ? age : undefined), week: week}},
                                title: start.formatRange(this.programmes[0].end_date)
                            });
                        }
                        this.$root.headers = {
                            navigate: {
                                name: (individual_days ? 'booking.age' : 'booking.weeks'),
                                query: {
                                    age: (individual_days || !this.$route.query.age ? undefined : this.$route.query.age),
                                    min_age: (individual_days || !this.$route.query.min_age ? undefined : this.$route.query.min_age),
                                }
                            },
                            title: this.$root.locale.miscellaneous.page_headings.booking.select_base_programme,
                            breadcrumbs: breadcrumbs,
                            allow_change: true,

                        }
                    }
                    this.loading = false;
                })
            },
            progress: function (event, programme) {
                this.$emit('updatebuilder', {
                    method: 'append',
                    data: {
                        package: {
                            base: programme,
                            individual_days: this.individual_days
                        }
                    }
                });

                var query = {
                    age: this.age,
                    min_age: this.min_age,
                    week: (this.individual_days ? undefined : this.week),
                    base: programme.id,
                    days: (programme.price_per == "day" ? true : undefined),
                    // is_week: ()
                }
                //Checking whether there is only 1 base package available,
                // if so replace the url without storing this page in the history,
                // else just continue as normal.
                if (this.programmes.length == 1) {
                    var next_url = $.grep(this.$router.options.routes, function (e) {
                        return e.name == 'booking.packages.customize';
                    })[0].path;
                    var base = window.location.href.replace(this.$route.fullPath, '');
                    window.location.replace(base+next_url.replace(':venueId', this.$route.params.venueId)+'?'+jQuery.param(query));
                } else {
                    this.$router.push({name: 'booking.packages.customize', query});
                }
            },
        },
        created() {
            this.refresh();
        },
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// BasePackages.vue?478fdf94